<template>
  <ul>
    <li
      v-for="staticRoot in staticRoots"
      :key="staticRoot"
    >
      <span class="custom-code">{{staticRoot}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'StaticRootList',

  props: {
    staticRoots: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-left: 0;
}
</style>
